export enum MessageType {
	TEXT = 'TEXT',
	IMAGE = 'IMAGE',
	AUDIO = 'AUDIO',
	EMOJI = 'EMOJI',
	FILE = 'FILE',
	VIDEO = 'VIDEO',
}
